if (!Object.hasOwn) {
    Object.defineProperty(Object, 'hasOwn', {
        configurable: true,
        value(object: object, property: PropertyKey): boolean {
            return Object.prototype.hasOwnProperty.call(object, property);
        },
        writable: true,
    });
}
